import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFiles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 42,
	viewBox: "0 0 43 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21.5,
			cy: 21,
			r: 21,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5 22.4V25.4C26.5 29.4 24.9 31 20.9 31H17.1C13.1 31 11.5 29.4 11.5 25.4V21.6C11.5 17.6 13.1 16 17.1 16H20.1",
			stroke: "#BCA4FF",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4996 22.4H23.2996C20.8996 22.4 20.0996 21.6 20.0996 19.2V16L26.4996 22.4Z",
			stroke: "#BCA4FF",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0996 11H25.0996",
			stroke: "#BCA4FF",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 14C16.5 12.34 17.84 11 19.5 11H22.12",
			stroke: "#BCA4FF",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4995 17V23.19C31.4995 24.74 30.2395 26 28.6895 26",
			stroke: "#BCA4FF",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5 17H28.5C26.25 17 25.5 16.25 25.5 14V11L31.5 17Z",
			stroke: "#BCA4FF",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFiles;
